import { useRef, type MouseEvent } from "react";
import { useNavigate } from "react-router-dom";

const HOLD_MS = 5_000;

/** A hidden way in: holding a link goes somewhere else, and a normal tap still follows it. */
export function useHoldToOpen(path: string) {
  const navigate = useNavigate();
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const held = useRef(false);
  const cancel = (): void => clearTimeout(timer.current);
  return {
    onPointerDown: () => {
      held.current = false;
      cancel();
      timer.current = setTimeout(() => {
        held.current = true;
        navigate(path);
      }, HOLD_MS);
    },
    onPointerUp: cancel,
    onPointerLeave: cancel,
    onPointerCancel: cancel,
    onContextMenu: (event: MouseEvent) => event.preventDefault(),
    onClick: (event: MouseEvent) => {
      if (held.current) {
        event.preventDefault();
        held.current = false;
      }
    },
  };
}
